import React, { FunctionComponent, useState } from "react";
import { ReactComponent as StarEmpty } from '../../Assets/Svg/star-empty.svg';
import { ReactComponent as StarHalf } from '../../Assets/Svg/star-half.svg';
import { ReactComponent as StarFull } from '../../Assets/Svg/star-full.svg';
import './stars.scss';

type Props = {
    defaultValue: number
}

const Stars:FunctionComponent<Props> = ({defaultValue}) => {
    const [starsAmount] = useState([...Array(5)]);

    return(
        <div className="stars">
            {
                starsAmount.map((e, key) =>(
                    <div className="heart" key={key}>
                        {defaultValue > key ? defaultValue > key + 0.5 ? <StarFull/> : <StarHalf/> : <StarEmpty/>}
                    </div>
                ))
            }
        </div>
    )
};
export default Stars; 